import { ECHO_CALL_ENDED, ECHO_NEW_MESSAGE } from 'constants/realtimeEvent'
import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Close } from 'assets/icons/components'

import {
  Container,
  Item,
  Avatar,
  ItemContent,
  Content,
  Name,
  CloseAction
} from './style'
import { addConversation, setActiveConversation } from 'actions/chat'
import { setActiveSidebar, setMainContent } from 'actions/mainContent'
import { setIsFullScreen } from 'actions/videoCall'
import { HistoryServices } from 'services/index'
import { useTranslation } from 'react-i18next'
import i18n from 'config/i18n'
import { toast } from 'components/common/Toast'

const MessageNotification = (props) => {
  const { dispatch, newEvent, activeConversation, user,
    conversations
  } = props
  const [messages, setMessages] = useState([])
  const { t } = useTranslation('live', { i18n })

  useEffect(() => {
    if (!user) {
      setMessages([])
    }
  }, [user])

  useEffect(() => {
    if (!newEvent?.message?.read && newEvent?.event === ECHO_NEW_MESSAGE && newEvent?.message?.conversation?.token !== activeConversation?.token && 
        user?.uid !== newEvent?.message?.sender?.uid) {
        
        switch(newEvent?.message?.kind) {
          case 'danger':
            toast.error(newEvent?.message?.translate || newEvent?.message?.content)
            break;
          case 'call':
            toast.info(newEvent?.message?.translate || newEvent?.message?.content)
            break;
          case 'success':
            toast.success(newEvent?.message?.translate || newEvent?.message?.content)
            break;
          default:
            toast.dark(newEvent?.message?.sender?.name + ': ' + (newEvent?.message?.translate || newEvent?.message?.content))
            break;
        }
      
      // let allMessages  = [...messages, newEvent?.message]
      // setMessages(allMessages)

      // setTimeout(() => {
      //   handleRemoveMessage(newEvent?.message?.id)
      // }, 5000)
    }

    // if (newEvent?.event === ECHO_CALL_ENDED) {
      // let allMessages  = [...messages, {
      //   id: newEvent?.callId,
      //   content: t('{{name}} has left the session', { name: newEvent?.user?.name }),
      //   sender: newEvent?.user,
      //   isCall: true
      // }]

      // setMessages(allMessages)

      // setTimeout(() => {
      //   handleRemoveMessage(newEvent?.callId)
      // }, 5000)
    // }
  }, [newEvent])

  const handleRemoveMessage = (messageId) => {
    let filteredMessages = messages.filter(m => m?.id !== messageId)

    setMessages(filteredMessages)
  }

  const handleOpenConversation = async (message) => {
    handleRemoveMessage(message?.id)

    if (message?.isCall) return

    await getConversationByToken(message?.conversation?.token)
    dispatch(setActiveSidebar('messages'))
    dispatch(setMainContent('chat'))
    dispatch(setIsFullScreen(false))
  }

  const getConversationByToken = async (token) => {
    let existsConversation = conversations.find(item => item?.token === token)

    if (!existsConversation) {
      let { conversation } = await HistoryServices.getConversation(token)
      existsConversation = conversation
    }

    if (existsConversation) {
      dispatch(addConversation(existsConversation))
      dispatch(setActiveConversation(existsConversation))
    }
  }

  return (
    <Container isShow={messages.length > 0}>
      { messages.map(message => 
        <Item onClick={() => handleOpenConversation(message)} key={message?.id}>
          {
            !message?.isCall &&
            <CloseAction onClick={(e) => { e.stopPropagation();handleRemoveMessage(message?.id) }}>
              <Close />
            </CloseAction>
          }
          <Avatar src={ message?.sender?.avatar } />
          <ItemContent>
            <Name>{ message?.sender?.name }</Name>
            <Content>{ message?.translate || message?.content }</Content>
          </ItemContent>
        </Item>
      )}
    </Container>
  )
}

const mapStateToProps = (state) => ({
  newEvent: state.echoReducer.newEvent,
  activeConversation: state.chatReducer.activeConversation,
  user: state.connectionReducer.user,
  conversations: state.chatReducer.conversations,
})

export default connect(mapStateToProps)(MessageNotification)